import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { isFeatureEnabled } from "@editor/infra/featureFlags";

import ProjectFunnelsPages from "../react-editor/components/ProjectFunnelsPages";
import CreateFunnel from "./components/CreateFunnel";

function Funnel() {
  const isReaplo = isFeatureEnabled("reaplo");
  const projectId = useCurrentProjectId();

  if (!isReaplo) {
    window.location.href = `/projects/${projectId}`;
    return null;
  }

  return (
    <div className="flex h-screen flex-col gap-3 p-3 overflow-y-auto">
      <div className="text-lg font-medium">
        All Funnels and Pages for this project
      </div>
      <div className="flex w-1/2">
        <CreateFunnel />
      </div>

      <div className="flex flex-col gap-2">
        <ProjectFunnelsPages />
      </div>
    </div>
  );
}

export default Funnel;
